// This will soon be in sui-js package
// part of the code extracted from. https://github.com/epeli/underscore.string/blob/master/cleanDiacritics.js
const from = 'ąàáäâãåæăćčĉęèéëêĝĥìíïîĵłľńňòóöőôõðøśșşšŝťțţŭùúüűûñÿýçżźž'
const to = 'aaaaaaaaaccceeeeeghiiiijllnnoooooooossssstttuuuuuunyyczzz'.split('')

function replaceCharIfNeeded(char) {
  const index = from.indexOf(char)
  return index === -1 ? char : to[index]
}

function transformToKebabCase(str, allowQueryParams) {
  const validCharsRegEx = allowQueryParams
    ? /[^a-z0-9\\. \- _ ? =]/g // only letters numbers, dahses, low dashes, dots, equals and question marks
    : /[^a-z0-9\\. \- _]/g // only letters numbers, dahses, low dashes and dots

  return str
    .toLowerCase()
    .replace(/.{1}/g, replaceCharIfNeeded)
    .replace(validCharsRegEx, '') // remove invalid chars
    .replace(/\s/g, '_') // collapse whitespace and replace by _
}

export const getMakeModelSlugs = ({ad}) => {
  const make = ad.make?.name
  const model = ad.model?.name
  if (!make || !model) return null
  const makeSlug = transformToKebabCase(make)
  const modelSlug = transformToKebabCase(model)
  return {makeSlug, modelSlug}
}
